import React, { Component } from 'react';

class GetHeadsUpApp extends Component {
    state = {};
    getMobileOperatingSystem() {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // Detect Android
        const isAndroid = /Android/.test(navigator.userAgent);

        // Example usage
        if (isIOS) {
            window.location.href = "https://apps.apple.com/lb/app/heads-up-party-game/id0000000000";
        } else if (isAndroid) {
            window.location.href = "https://play.google.com/store/apps/details?id=com.headsup";
        } else {
            window.location.href = "https://headsup-game.web.app/";
        }
    }
    render() {
        this.getMobileOperatingSystem()
        return (
               <div></div>
        );
    }
}

export default GetHeadsUpApp;
